var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const objectFromEntries = Object.fromEntries;
export const objectEntries = Object.entries;
export const objectKeys = Object.keys;
export const objectValues = Object.values;
export const objectIsEmpty = (obj) => objectValues(obj).filter((v) => v !== undefined && v !== null).length === 0;
/**
 * This is just a way to get TypeBox Static<> types to show up better in type inference. Ignore this type.
 */
class FixTsMappedTypes {
}
export const firstNameLastNameFromName = (name) => {
    // This isn't very exact at all as firstnames can have spaces in them
    // so this is just a best guess
    const parts = name.split(' ');
    const firstName = parts[0];
    const lastName = parts.slice(1).join(' ');
    return { firstName, lastName };
};
export const createRandomId = () => {
    var _a;
    if ((_a = globalThis.crypto) === null || _a === void 0 ? void 0 : _a.randomUUID) {
        return globalThis.crypto.randomUUID();
    }
    return `${numberToString(Math.random())}-${numberToString(Math.random())}-${numberToString(Date.now())}`;
};
const numberToString = (n) => n.toString(36).substring(2);
export const assertUnreachable = (_) => {
    throw new Error('Unreachable code reached');
};
export const toMinorUnits = (amount) => Math.round(amount * 100);
const isLocalStorageAvailable = () => {
    if (typeof window === 'undefined' || !window.localStorage) {
        return false;
    }
    try {
        const testKey = '__test__';
        window.localStorage.setItem(testKey, testKey);
        window.localStorage.removeItem(testKey);
        return true;
    }
    catch (_a) {
        return false;
    }
};
export const withLocalStorageCache = (cacheKey, expiryMs, fetchFn) => __awaiter(void 0, void 0, void 0, function* () {
    let cached;
    if (isLocalStorageAvailable()) {
        try {
            const cachedData = window.localStorage.getItem(cacheKey);
            if (cachedData) {
                cached = JSON.parse(cachedData);
                const now = Date.now();
                if (cached.timestamp && now - cached.timestamp < expiryMs) {
                    return cached.data;
                }
            }
        }
        catch (error) {
            console.warn(`Error reading cache from localStorage (${cacheKey}):`, error);
        }
    }
    const fresh = yield fetchFn();
    if (isLocalStorageAvailable()) {
        try {
            const cacheData = { data: fresh, timestamp: Date.now() };
            window.localStorage.setItem(cacheKey, JSON.stringify(cacheData));
        }
        catch (error) {
            console.warn(`Error saving data to localStorage (${cacheKey}):`, error);
        }
    }
    return fresh;
});
export const createMemoizedFunction = (fetchFn) => {
    let promise;
    return () => {
        if (promise === undefined) {
            promise = fetchFn();
        }
        return promise;
    };
};
//# sourceMappingURL=utils.js.map